import { render } from "./HomeTab.vue?vue&type=template&id=52746b1f&scoped=true"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"

import "./HomeTab.vue?vue&type=style&index=0&id=52746b1f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52746b1f"]])

export default __exports__